import { Component } from '@angular/core';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-home-carousel',
  styleUrls: ['./home-carousel.component.scss'],
  templateUrl: './home-carousel.component.html'
})

export class HomeCarouselComponent {

  private showNavigationArrows = false;
  private showNavigationIndicators = false;

  constructor(config: NgbCarouselConfig) {
    config.interval = 2000;
    config.showNavigationArrows = false;
    config.showNavigationIndicators = false;
  }
}
